import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import dayjs from 'dayjs';

import {migrateLegacyAuthIfNeeded} from '@services/utils';

import {App} from './App';

import '@fontsource-variable/inter/index.css';
import '@styles/tokens.css';
import '@styles/reset.css';
import '@styles/antd-overrides.css';

import 'dayjs/locale/ru';

// Глобально включаем русскую локаль для всех `dayjs().format(...)`
// в проекте — месяцы и дни недели должны быть только на русском.
dayjs.locale('ru');

// Миграция auth-сессии из старой showgo-office (тот же домен, другие
// ключи в localStorage). Синхронно — до первого рендера, чтобы
// `atomWithStorage({getOnInit: true})` увидел уже разложенные ключи.
migrateLegacyAuthIfNeeded();

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root element in index.html');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
